export function sandboxLocationOverrideAllowed(requested, environment) {
    return requested === true && environment === 'sandbox';
}
